import { shallowRef } from "vue";
import { tryOnScopeDispose } from "@vueuse/core";
export const useAutoExpiringQueue = (ttl, cap) => {
    const items = shallowRef([]);
    const timers = new Map();
    let paused = false;
    const resolveTtl = typeof ttl === "function" ? ttl : (_item) => ttl;
    const remove = (id) => {
        const timer = timers.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.delete(id);
        }
        items.value = items.value.filter((item) => item.id !== id);
    };
    const arm = (id) => {
        if (paused)
            return;
        const item = items.value.find((i) => i.id === id);
        if (!item)
            return;
        const delay = resolveTtl(item);
        if (delay === null || !Number.isFinite(delay) || delay <= 0)
            return; // permanent / invalid — never auto-expires
        const existing = timers.get(id);
        if (existing)
            clearTimeout(existing);
        timers.set(id, setTimeout(() => remove(id), delay));
    };
    const add = (item) => {
        if (cap !== undefined && cap > 0 && items.value.length >= cap) {
            remove(items.value[0].id);
        }
        items.value = [...items.value, item];
        arm(item.id);
    };
    // Elapsed time is not preserved, resume() gives each item a fresh full TTL.
    // Intentional: attention (hover, blocking toast) should reset the countdown.
    const pause = () => {
        paused = true;
        timers.forEach((timer) => clearTimeout(timer));
        timers.clear();
    };
    const resume = () => {
        if (!paused)
            return;
        paused = false;
        items.value.forEach((item) => arm(item.id));
    };
    const clear = () => {
        timers.forEach((timer) => clearTimeout(timer));
        timers.clear();
        items.value = [];
        paused = false;
    };
    tryOnScopeDispose(clear);
    return { items, add, remove, pause, resume, clear };
};
